<section class="section section--border funnel-entry-sticky" [ngClass]="{'funnel-entry-sticky--show': show}">
    <div class="container">
        <ng-content></ng-content>
    </div>
</section>